import { gql } from '@apollo/client';

export default gql`
  query GetProjectUsers(
    $projectId: ID!
    $first: Int
    $after: String
    $orderBy: ProjectUserOrderField!
    $includeInactiveUsers: Boolean
  ) {
    viewer {
      __typename
      id
      project(id: $projectId) {
        __typename
        id
        projectUserCount
        projectUsers(
          first: $first
          after: $after
          orderBy: $orderBy
          includeInactiveUsers: $includeInactiveUsers
        ) {
          pageInfo {
            hasNextPage
            endCursor
          }
          edges {
            node {
              __typename
              id
              name
              lastContributedAt
              assignedAt
              avatar
              colorCode
              company {
                __typename
                id
                name
              }
              assignedUser {
                __typename
                id
                isDeleted
                status
                emailAddress
                phoneNumber
                createdAt
              }
            }
          }
        }
      }
    }
  }
`;
